import { Row } from '../Row';
import { formatTimePlaced } from '../../../utils/formatTimePlaced';
import React from 'react';

export type HeaderProps = {
	id: string;
	timePlaced: string;
};

export const Header: React.FC<HeaderProps> = ({ id, timePlaced }) => (
	<Row align="center" className="py-2 order-card-header">
		<h4 className="mb-0">
			Order{' '}
			<span className="text-primary font-weight-light">
				{id.substring(24)}
			</span>
		</h4>

		<h6 className="mb-0 text-muted font-weight-normal">
			{formatTimePlaced(timePlaced)}
		</h6>
	</Row>
);
